module.exports = __webpack_public_path__ + "img/product-thinboard.dba5c113.png";